import { render } from "./PricingCard.vue?vue&type=template&id=e9e6a2a0&scoped=true"
import script from "./PricingCard.vue?vue&type=script&lang=js"
export * from "./PricingCard.vue?vue&type=script&lang=js"

import "./PricingCard.vue?vue&type=style&index=0&id=e9e6a2a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9e6a2a0"]])

export default __exports__